/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Maëlle MONTINERI
 * @date        22/10/2019 11:49
 * @copyright   Copyright (c) 2002-2019 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';

export class GalleryCpnt {
    constructor()
    {
        this.initializeGallery();
    }
    
    initializeGallery()
    {
        let grid            = document.querySelector('.js-grid'),
            item            = '.js-gridItem',
            filterList      = $('.js-filterList'),
            active          = 'active';
    
        if ( $('.grid-sizer').length > 0 ) {
            if ( document.body.contains(grid) ) {
                
                $('.blog .postItem').addClass('js-gridItem');
    
                let iso = new Isotope( grid, {
                    masonry: {
                        columnWidth: '.grid-sizer',
                        gutter: 20,
                        itemSelector: item,
                        percentPosition: true
                    }
                } );
                
                // Layout Isotope after each image loads
                let imgLoad = new imagesLoaded( iso );
                imgLoad.on( 'progress', function () {
                    new Isotope( grid, 'layout' );
                });
                
                if ( filterList.length > 0 ) {
                    // Filter items on button click
                    filterList.on('click', 'li', function () {
                        let filterValue = $(this).attr('data-filter');
                        iso.arrange({filter: filterValue});
                    });
                    
                    // Change class on click
                    filterList.each(function (i, buttonGroup) {
                        let $buttonGroup = $(buttonGroup);
                        $buttonGroup.on('click', 'li', function () {
                            $buttonGroup.find('.' + active).removeClass(active);
                            $(this).addClass(active);
                        });
                    });
                }
            }
        }
    }
}